var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardNoBookmarked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    height: 18,
    viewBox: "0 0 14 18",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.9 18c-.2 0-.3 0-.5-.1-.2-.2-.4-.5-.4-.8v-16.2c0-.5.4-.9.9-.9h12.2c.5 0 .9.4.9.9v16.3c0 .3-.2.6-.4.7-.3.2-.6.2-.9 0l-5.5-3-5.9 3c-.1.1-.3.1-.4.1zm.9-16.3v14l5-2.5c.3-.1.6-.1.9 0l4.6 2.5v-14z",
    fill: "#282d3d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNoBookmarked);
export default __webpack_public_path__ + "static/media/card-no-bookmarked.eb80556f.svg";
export { ForwardRef as ReactComponent };